export default "__VITE_ASSET__f11889d5__"